var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsftColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04349 5.04349H15.4783V15.4783H5.04349V5.04349Z",
    fill: "#F35325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5217 5.04349H26.9565V15.4783H16.5217V5.04349Z",
    fill: "#81BC06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04349 16.5217H15.4783V26.9565H5.04349V16.5217Z",
    fill: "#05A6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5217 16.5217H26.9565V26.9565H16.5217V16.5217Z",
    fill: "#FFBA08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsftColor);
export default __webpack_public_path__ + "static/media/MsftColor.02b2f4f8f484a108d2cc6d622608baf5.svg";
export { ForwardRef as ReactComponent };